import { Subject } from "rxjs/Subject";
import { SplatState } from "./splat-state.interface";
import { SplatImageMap } from "./splat-image-map.model";
import { EventEmitter } from "@angular/core";
import { SplatModel } from "./splat-model.model";
import { Point } from "./point.interface";
import { SplatImage } from "./splat-image.model";

export class SplatRenderer {

    protected canvas: HTMLCanvasElement;
    protected ctx: any;
    protected state$: Subject<SplatState>;
    protected ngUnsubscribe: Subject<void> = new Subject<void>();
    protected imageMap: SplatImageMap;
    protected events: EventEmitter<any> = new EventEmitter();
    protected subscribers: Array<any> = [];

    constructor(canvas: HTMLCanvasElement, model: SplatModel, imageMap: SplatImageMap) {
        this.canvas = canvas;
        this.ctx = canvas.getContext("2d");
        this.state$ = model.state$;
        this.imageMap = imageMap;

        this.state$.takeUntil(this.ngUnsubscribe).subscribe((state: SplatState) => this.render(state));

        imageMap.loadAll().then(
            () => {
                this.triggerOnReady();
            },
            () => {
                console.error("image map failed to load");
            }
        );
    }

    onReady(callback: () => any): void {
        this.subscribers.push(this.events.subscribe(callback));
    }

    triggerOnReady(): void {
        this.events.emit();
    }

    adjustPoint(p: Point): Point {
        const b: any = this.canvas.getBoundingClientRect();

        const r: any = (this.canvas.height / this.canvas.offsetHeight);

        return {
            x: (p.x - b.left) * r,
            y: (p.y - b.top) * r
        };
    }

    render(state: SplatState): void {

        const bgImage: SplatImage = this.imageMap.getImage(state.background);

        if (!bgImage) {
            throw new Error(`invalid background image "${state.background}"`);
        }

        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

        this.ctx.drawImage(bgImage.img, 0, 0, this.canvas.width, this.canvas.height);

        Object.keys(state.objects.entities).map(key => state.objects.entities[key]).forEach(splat => {

            this.ctx.save();

            this.ctx.translate(splat.center.x, splat.center.y);

            if (splat.rotation) {
                this.ctx.rotate(splat.rotation * Math.PI / 180);
            }

            this.ctx.drawImage(splat.image.img, -splat.image.size.w / 2, -splat.image.size.h / 2);

            if (splat.selected) {
                this.ctx.beginPath();
                this.ctx.setLineDash([5, 5]);
                this.ctx.lineDashOffset = 5;
                this.ctx.rect(-splat.image.size.w / 2, -splat.image.size.h / 2, splat.image.size.w, splat.image.size.h);
                this.ctx.stroke();
                this.ctx.setLineDash([]);
                this.ctx.lineDashOffset = 0;
                this.ctx.closePath();
            }

            this.ctx.restore();
        });
    }

    destroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
        this.subscribers.forEach(s => {
            s.unsubscribe();
        });
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/splat/form/lib/splat-renderer.model.ts